<template>
  <div id="app">
    <img src="./assets/2026_Logo_GMBCH.jpg" style="height: 30vh;">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
    };
  },
  props: ['awsconfig'],
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue